import { render } from "./attestation.vue?vue&type=template&id=30f1f6a4&scoped=true&ts=true"
import script from "./attestation.vue?vue&type=script&lang=ts"
export * from "./attestation.vue?vue&type=script&lang=ts"

import "./attestation.vue?vue&type=style&index=0&id=30f1f6a4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30f1f6a4"],['__file',"src/vue/sections-formulaire/attestation.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "30f1f6a4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('30f1f6a4', __exports__)) {
    api.reload('30f1f6a4', __exports__)
  }
  
  module.hot.accept("./attestation.vue?vue&type=template&id=30f1f6a4&scoped=true&ts=true", () => {
    api.rerender('30f1f6a4', render)
  })

}


export default __exports__